import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import ScrollReveal from "scrollreveal";
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function buildFormat() {
      var $toc = $('<div />', {id: 'toc_container'});
      var $list = $('<ul />', {class: 'toc_list'});
      var $groups = $('.u-format-group');
      // フォーマットグループごとの処理
      for (var i = 0; i < $groups.length; i++) {
        var $_list = $('<ul />');
        var $group = $($groups[i]);
        var group_title = $group.find('.u-format-group__title').text();
        var $group_li = $('<li />');
        var groupid = 'formatgroup_' + (i + 1);
        $group.attr('id', groupid);
        $list.append(
          $group_li.append(
            $('<a />',
              {
                text: (i + 1) + '. ' + group_title,
                href: '#' + groupid
              }
            )
          )
        );
        // フォーマットごとの処理
        var $formats = $group.find('.u-format-group__content').find('.u-format');
        var $_ul = $('<ul />');
        for (var m = 0; m < $formats.length; m++) {
          var $format = $($formats[m]);
          var $format_title = $format.find('.u-format__title');
          var $format_content = $format.find('.u-format__content');
          var formatid = 'format_' + (i + 1) + (m + 1);
          $format.find('.u-format__title').attr('id', formatid);
          var format_title = $format_title.text();
          var format_number = (i + 1) + '.' + (m + 1) + '. ';
          $format_title.text(format_number + format_title);
          $_ul.append(
            $('<li />').append(
              $('<a />', {
                  href: '#' + formatid,
                  text: format_number + format_title
                }
              )
            )
          );

          // コードを追加
          var $code = $('<div />', {class: 'u-format__code'});
          $code.append($('<div />', {
            class: 'u-format__code__title',
            text: format_number + format_title
          }));
          var formathtml = $format.find('.u-format__content').html();
          $code.append($('<pre />', {text: formathtml.trim()}));
          $format.append($code);
        }
        $group_li.append($_ul);
        $_list.append($group_li);
        $list.append($_list);
      }
      $toc.append($list);
      $('.c-breadcrumb').after(
        $('<div />', {
            class: 'l-container'
          }
        ).append($toc)
      );
    }


    $(function () {

      //owlcarousel
      function owlcarousel() {
        var $infinitegallery = $(".c-infinite-gallery__inner");
        var $mainvisual = $('.c-mainvisual-slider');
        var $recruitslider = $('.c-recruit-slider');

        if ($recruitslider.length !== 0) {
          $recruitslider.owlCarousel({
            items: 1,
            margin: 0,
            dots: false,
            loop: true,
            nav: false,
            autoplayHoverPause: true,
            autoplay: true,
            pullDrag: false,
            mouseDrag: false,
            autoplaySpeed: 500,
            animateOut: 'fadeOut',
            center: true,
          });
        }
        if ($mainvisual.length !== 0) {
          $mainvisual.owlCarousel({
            items: 1,
            margin: 0,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 500,
            center: true,
            navText: ['<img src="/assets/images/icon-slider-prev.svg" />', '<img src="/assets/images/icon-slider-next.svg" />'],
          });
        }

        if ($infinitegallery.length !== 0) {
          var scDuration = 30000;
          $infinitegallery.owlCarousel({
            responsiveClass: true,
            responsive: {
              0: {
                items: 2,
                autoWidth: true,
                loop: true,
                margin: 0,
                center: false,
                nav: false,
                dot: false,
                lazyLoad: true,
                autoplayHoverPause: false,
                autoplay: true,
                fallbackEasing: 'linear',
                smartSpeed: scDuration,
                autoplaySpeed: scDuration,
                autoplayTimeout: 800,
                navText: '',
                mouseDrag: false,
                touchDrag: false,
              },
              640: {
                items: 3,
                autoWidth: true,
                loop: true,
                margin: 0,
                center: false,
                nav: false,
                dot: false,
                lazyLoad: true,
                autoplayHoverPause: false,
                autoplay: true,
                fallbackEasing: 'linear',
                smartSpeed: scDuration,
                autoplaySpeed: scDuration,
                autoplayTimeout: 800,
                navText: '',
                mouseDrag: false,
                touchDrag: false,
              },
              1000: {
                items: 5,
                autoWidth: true,
                loop: true,
                margin: 0,
                center: false,
                nav: false,
                dot: false,
                lazyLoad: true,
                autoplayHoverPause: false,
                autoplay: true,
                fallbackEasing: 'linear',
                smartSpeed: scDuration,
                autoplaySpeed: scDuration,
                autoplayTimeout: 800,
                navText: '',
                mouseDrag: false,
                touchDrag: false,
              }
            }


          });
          // setInterval(function () {
          //   $infinitegallery.trigger('next.owl.carousel');
          // }, scDuration);
        }
      }

      function clinicGallery() {
        // サムネイルをホバーしたらメインイメージに表示
        var $main = $(".p-gallery__main");
        var $subs = $(".p-gallery__sub");
        if ($main.length === 0 || $subs.length === 0) {
          return false;
        }

        var $sub = $(".p-gallery__sub__block");
        $sub.hover(function () {
          var imageName = $(this).find('.p-gallery__sub__image > div').css("background-image");
          $sub.removeClass('is-active');
          $(this).addClass('is-active');
          $main.find('.p-gallery__main__image').css("background-image", imageName);
        });

      }

      function scrollReveal() {

        // スクロールリーバル
        window.sr = new ScrollReveal({duration: 600, mobile: true});

        function domEach(items, callback) {
          if (typeof items === "string") {
            var items = $(items);
          }

          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // callback = callback.bind(item)
            callback(i, item);
          }
        }

        var duration_base = 1000;
        var delay_base = 1000;


        sr.reveal(".js-reveal-slide-in", {
          scale: 1,
          duration: duration_base ,
          distance: '20px',
          origin: 'left',
          delay: delay_base * 1,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-slide-in2", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'left',
          delay: delay_base * 1.6,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-slide-in3", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'left',
          delay: delay_base * 1.8,
          easing: 'ease'
        }, 100);


        sr.reveal(".js-reveal-fade", {
          scale: 1,
          duration: duration_base,
          distance: '0',
          delay: delay_base * 0.1,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-fade2", {
          scale: 1,
          duration: duration_base,
          distance: '0',
          delay: delay_base * 0.8,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-fade3", {
          scale: 1,
          duration: duration_base,
          distance: '0',
          delay: delay_base * 1.6,
          easing: 'ease'
        }, 100);


        sr.reveal(".js-reveal-slide-down, h2.heading.is-xlg, .c-lead-catch__title", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 0.1,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-slide-down2,.c-image-half-block__num strong", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 0.8,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-slide-down3", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 1.2,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-slide-up", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'bottom',
          delay: delay_base * 0.1,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-slide-up2", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'bottom',
          delay: delay_base * 0.8,
          easing: 'ease'
        }, 100);
        sr.reveal(".js-reveal-slide-up3", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'bottom',
          delay: delay_base * 1.2,
          easing: 'ease'
        }, 100);

        function domEach(items, callback) {
          if (typeof items === "string") {
            var items = $(items);
          }

          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // callback = callback.bind(item)
            callback(i, item);
          }
        }
        // header

        sr.reveal(".c-page-header", {
          scale: 1,
          duration: duration_base,
          distance: '0',
          delay: delay_base * 0.1,
          easing: 'ease'
        }, 100);

        // harf-box

        sr.reveal(".c-image-half-block__num img", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 0.1,
          easing: 'ease'
        }, 100);
        sr.reveal(".c-image-half-block__num strong,.c-message__visual", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 0.2,
          easing: 'ease'
        }, 100);
        sr.reveal(".c-image-half-block__image", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'bottom',
          delay: delay_base * 0.3,
          easing: 'ease'
        }, 100);
        sr.reveal(".c-image-half-block__icon,.c-message__content", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 0.4,
          easing: 'ease'
        }, 100);
        sr.reveal(".c-image-half-block__title", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 0.5,
          easing: 'ease'
        }, 100);
        sr.reveal(".c-image-half-block__text", {
          scale: 1,
          duration: duration_base,
          distance: '20px',
          origin: 'top',
          delay: delay_base * 0.5,
          easing: 'ease'
        }, 100);

        var blocks01 = $(".js-reveal-chain,.c-card-circle__inner");
        domEach(blocks01, function (key, item) {
          sr.reveal(item.children[0], {delay: 500, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[1], {delay: 500, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[2], {delay: 600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[3], {delay: 700, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[4], {delay: 800, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[5], {delay: 900, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[6], {delay: 1000, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[7], {delay: 1100, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[8], {delay: 1200, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[9], {delay: 1300, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[10], {delay: 1400, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 10);
          sr.reveal(item.children[11], {delay: 1500, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
          sr.reveal(item.children[12], {delay: 1600, scale: 1, duration: 400, distance: '10px', easing: 'ease'}, 100);
        });
      }
      owlcarousel();
      clinicGallery();
      scrollReveal();

    });

    // buildFormat();
  }
}

window.GApp = new App();
